export const visit = (vm, at) => {
at({ "da": { "conversationsVisitorUIAvailability": { "sameDay": "Vi vender tilbage i dag kl. {{time}}", "nextDay": "Vi vender tilbage i morgen kl. {{time}}", "nextWeek": "Vi vender tilbage p\xE5 {{dayOfWeek}} kl. {{time}}" } } });
};